module.exports = __webpack_public_path__ + "static/media/LEDs.79660576.logo";